/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // // Debounced scroll listeners.  Up and down only fire on direction changes
  // // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  if(document.querySelector('.form__selectors .radio__fieldset [data-swapper-target]')) {
    const targetNode = document.querySelector('.form__selectors .radio__fieldset [data-swapper-target]');
    const config = { childList: true, subtree: true };
    let currentValue = targetNode.innerText;

    const callback = function(mutationsList, observer) {
      if(currentValue !== targetNode.innerText) {
        currentValue = targetNode.innerText;
        let text = targetNode.innerText;
        let words = text.toLowerCase().split(' ');
        for(let v = 0; v < words.length; v++) {
            words[v] = words[v].charAt(0).toUpperCase() + words[v].slice(1)
        }
        let new_text = words.join(' ');
        targetNode.innerText = new_text;
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  const targetNode1 = document;
  const config1 = { childList: true, subtree: true };

  const callback1 = function() {
    observeButtons(document.querySelectorAll('.boost-sd__popup-select-option:not(.listening)'));
    let list = [];
    document.querySelectorAll('.boost-sd__product-image-column:not(.listening) .boost-sd__btn-add-to-cart').forEach((button)=>{
      list.push(button.closest('.boost-sd__product-image-column'));
    });
    observeButtons(list);
    document.querySelectorAll('.boost-sd__product-link:not(.observing)').forEach((ele)=>{
      ele.classList.add('observing');
      ele.addEventListener('click',(e)=>{
        if(!e.target.classList.contains('boost-sd__product-image-img')){
          e.preventDefault();
        }
      });
    });
  };

  const observer1 = new MutationObserver(callback1);
  observer1.observe(targetNode1, config1);

  function observeButtons(buttons) {
    let config2 = { attributes: true, childList: true, subtree: true };
    buttons.forEach((buttonHolder)=>{
      let targetNode2 = buttonHolder;
      targetNode2.classList.add('listening');
      let callback2 = function() {
        if(targetNode2.querySelectorAll('button.boost-sd__button:not(.added)').length == 1) {
          if(targetNode2.querySelector('button.boost-sd__button:not(.added) .boost-sd__button-text') && targetNode2.querySelector('button.boost-sd__button:not(.added) .boost-sd__button-text').innerText.trim() == 'Adding...') {
            targetNode2.querySelector('button.boost-sd__button:not(.added)').classList.add('added');
          }
          else if(targetNode2.querySelector('button.boost-sd__button.added .boost-sd__button-text') && targetNode2.querySelector('button.boost-sd__button.added .boost-sd__button-text').innerText.trim() == 'Add to cart') {
            targetNode2.querySelector('button.boost-sd__button.added').classList.remove('added');
          }
        }
        else if(targetNode2.querySelector('button.boost-sd__button[aria-label]:not(.added)') && targetNode2.querySelector('button.boost-sd__button[aria-label]:not(.added)').innerText.trim() == 'Adding...') {
          targetNode2.querySelector('button.boost-sd__button[aria-label]:not(.added)').classList.add('added');
        }
        else if(targetNode2.querySelector('button.boost-sd__button[aria-label].added') && targetNode2.querySelector('button.boost-sd__button[aria-label].added').innerText.trim() == 'Add to cart') {
          targetNode2.querySelector('button.boost-sd__button[aria-label].added').classList.remove('added');
        }
      };
      let observer2 = new MutationObserver(callback2);
      observer2.observe(targetNode2, config2);
    });
  }

  const artistsLinks = document.querySelector('[data-custom-artists]');

  if (artistsLinks) {
    const artists = Array.from(artistsLinks.querySelectorAll('[data-artist-handle]'));
    const artistImage = artistsLinks.querySelector('[data-artist-image-element]');
    const artistProductImage = artistsLinks.querySelector('[data-artist-product-image-element]');
  
    artists.forEach((artist, index) => {
      artist.addEventListener('mouseenter', () => {
        const artistProductImageLink = artist.dataset.artistProductImage;
        const artistImageLink = artist.dataset.artistImage;
  
        if (artistProductImageLink != undefined) {
          artistImage.src = artistImageLink;
          artistProductImage.src = artistProductImageLink;
        } else {
          artists[0].dispatchEvent(new MouseEvent('mouseenter'));
        }
      });
  
      if (index === 0) {
        artist.dispatchEvent(new MouseEvent('mouseenter'));
      }
    });
  }
})();

document.addEventListener("click", function(e){

  if(e.target.classList.contains('boost-sd__button') && e.target.closest(".boost-sd__product-item")){

    setTimeout(function() {

      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {

          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              bubbles: false,
              detail: {
                cart: data
              }
            })
          );

          document.dispatchEvent(
            new CustomEvent('theme:cart:reload', {
              bubbles: false,
            })
          );

          document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
            new CustomEvent('theme:drawer:open', {
              bubbles: false,
            })
          );

          return data;
        });
    }, 1000);
  }
});
